import { useMemo } from "react";

import { isIndexNotInRange } from "Utils/Array";
import { getItemById } from "Utils/Item";
import { getRelevantAddresses } from "Utils/Relevance";
import { isNullOrWhiteSpace } from "Utils/String";
import { IUseProjectItem } from "./IUseProjectItem";
import { useProject } from "./UseProject";

export function useProjectItem(projectId: string, projectItemId: string): IUseProjectItem {
  const project = useProject(projectId);

  const projectItem = useMemo(() => {
    if (isNullOrWhiteSpace(projectItemId)) {
      return null;
    }

    const item = getItemById(project, projectItemId);

    if (item == null) {
      return null;
    }

    return item;
  }, [project, projectItemId]);

  const nextProjectItemId = useMemo(() => {
    const relevantItems = getRelevantAddresses(project);
    const index = relevantItems.findIndex((i) => i[`@id`] === projectItemId);

    if (isIndexNotInRange(relevantItems, index + 1)) {
      return null;
    }

    return relevantItems[index + 1][`@id`];
  }, [project, projectItemId]);

  return {
    nextProjectItemId,
    project,
    projectItem
  };
}
